import React from 'react';
import { Grid } from '@mui/material';
import { CardViewTextRow } from 'ui/viewComponents';
import { isSubscriptionStartedAction } from '../models/Action';
import { ActionCardBase } from './ActionCardBase';
import { ActionCardModalComponentProps } from './ActionCardModalComponent';

const ActionCardSubscriptionStarted: React.FC<ActionCardModalComponentProps> = ({ action }) => {
    if (!isSubscriptionStartedAction(action)) {
        return <ActionCardBase action={action} broken />;
    }

    const { subscriptionId, subscriptionSchemeId } = action.metadata;

    return (
        <ActionCardBase action={action} showDate>
            <Grid container spacing={1}>
                <Grid size={6}>
                    <CardViewTextRow title="Subscription ID" value={subscriptionId} noTransform />
                </Grid>
                <Grid size={6}>
                    <CardViewTextRow title="Scheme ID" value={subscriptionSchemeId} noTransform />
                </Grid>
            </Grid>
        </ActionCardBase>
    );
};

export default ActionCardSubscriptionStarted;
